/*!
Copyright (C) 2022 Liberty Infrasystems. All rights reserved.
*/

/* eslint-disable no-console, no-await-in-loop */

import axios from 'axios';
import { requestWithRetry } from './retry.js';
import { generateIdempotencyKey } from './idkey.js';

async function getData(axiosRequest) {
    const response = await axios.request(axiosRequest);
    return response.data;
}

async function getJson(url, query = null, { requestHeaders = {}, timeout = 5000, maxAttempts = 5 } = {}) {
    return requestWithRetry(
        async () => {
            return getData({
                method: 'get',
                url,
                params: query,
                headers: {
                    Accept: 'application/json',
                    ...requestHeaders,
                },
                timeout,
            });
        },
        {
            maxAttempts,
        },
    );
}

async function postJsonAcceptJson(url, data, query = null, { requestHeaders = {}, timeout = 5000, maxAttempts = 5 } = {}) {
    const idempotencyKey = generateIdempotencyKey();
    return requestWithRetry(
        async () => {
            return getData({
                method: 'post',
                url,
                params: query,
                headers: {
                    Accept: 'application/json',
                    'Idempotency-Key': idempotencyKey,
                    ...requestHeaders,
                },
                data,
                timeout,
            });
        },
        {
            maxAttempts,
        },
    );
}


export { getJson, postJsonAcceptJson };
